console.log("init Proteus treatments -- 1.01")

async function submitVariantViaProductForm(variantId, qty = 1) {
  const form = document.getElementById("hidden-product-form");
  if (!form) throw new Error("Hidden product form missing");

  // fill inputs
  form.querySelector('input[name="id"]').value = String(variantId);
  form.querySelector('input[name="quantity"]').value = String(qty);

  // wrap the event-driven flow in a Promise so we can await completion
  const done = new Promise((resolve) => {
    const onRefresh = (e) => {
      // product-form will dispatch cart:refresh with sections; resolve after it fires
      document.documentElement.removeEventListener("cart:refresh", onRefresh);
      resolve(e.detail);
    };
    document.documentElement.addEventListener("cart:refresh", onRefresh, { once: true });
  });

  // triggers ProductForm._onSubmit -> theme ajax add + events
  form.requestSubmit();

  return done; // resolves with the cart:refresh detail
}

// atc links
observeSelector('[href*="#atc--"]', atc_link => {

  if(document.querySelectorAll(`#hidden-product-form`).length == 0){
    document.querySelector('body').insertAdjacentHTML("beforeend", `
    <form is="product-form"
      id="hidden-product-form"
      action="/cart/add"
      method="post"
      style="display:none">
      <input type="hidden" name="id" value="">
      <input type="hidden" name="quantity" value="1">
    </form>  
    `);
  }

  atc_link.addEventListener("click", async (e) => {

    let atc_href = e.currentTarget.getAttribute("href");
    const match = atc_href.match(/#atc--([\d\-]+)/);
    if (!match) return;

    const var_ids = match[1].split("-"); // ["12345678", "3456789"]

    // Build items array for cart/add.js
    const items = var_ids.map(id => ({
      id,
      quantity: 1
    }));

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      console.log("Added multiple items:", data);

      waitForElement('#mini-cart').then(cart => {
        if(cart.open){
          cart.open = false;
        }

        setTimeout(() => {
          document.querySelector('a[href="/cart"][is="toggle-link"]').click();
        }, (500));

        setTimeout(() => {
          document.querySelector('a[href="/cart"][is="toggle-link"]').click();
          setTimeout(() => {
            document.querySelector('a[href="/cart"][is="toggle-link"]').click();
          }, (50));
        }, (2500));

      }).catch();

    } catch (err) {
      console.error("ATC error", err);
    }
  });
})

// joe: 40216908529798
// bar: 40216907939974